export default {"src":"/_next/static/media/stressMotivation.697ed9e1.svg","height":645,"width":1048,"blurWidth":0,"blurHeight":0};